// Public product specifications: SMO, SMI and SMP respectively.
export const smartlineThresholds = {
  '60_OUT': 'threshold_oak',
  '60_IN': 'threshold_alu',
  '60_OUT_PLUS': 'threshold_alu'
};

export const isSmartline = family => Object.prototype.hasOwnProperty.call(smartlineThresholds, family);
export const thresholdForFamily = (family, selected) => smartlineThresholds[family] || selected;
